"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchIcon = function SearchIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 32 32"
  }, props), _react.default.createElement("path", {
    d: "M31.561 29.44l-6.444-6.444a14.069 14.069 0 0 0 3.133-8.871C28.25 6.324 21.926 0 14.125 0S0 6.324 0 14.125 6.324 28.25 14.125 28.25a14.06 14.06 0 0 0 8.87-3.134l6.444 6.444c.293.293.676.439 1.061.439s.767-.146 1.061-.439a1.5 1.5 0 0 0 0-2.12zM3 14.125C3 7.991 7.991 3 14.125 3S25.25 7.991 25.25 14.125 20.259 25.25 14.125 25.25 3 20.26 3 14.125z"
  }));
};

SearchIcon.propTypes = {
  size: _propTypes.number
};
SearchIcon.defaultProps = {
  size: 40
};
var _default = SearchIcon;
exports.default = _default;